import {createContext, useState} from "react";
import {FaHome} from "react-icons/fa";

const PageContext = createContext({});

const PageProvider = (props) => {
  const [pageInfo, setPageInfo] = useState(
    {
      theme: 'light',
      titulo: 'Início',
      icone: <FaHome/>
    }
  );

  const value = {pageInfo, setPageInfo}

  return(
    <PageContext.Provider value={value}>
      {props.children}
    </PageContext.Provider>
  );
}

export {PageContext, PageProvider}